module.exports = "/_next/static/images/CollectAndBuild-aaa9f069928139b754afa0302cc4c9be.webp";